import { ArrowLeftColor } from "@components";
import { PATH_COMMUNITY_EVENT_DETAIL, PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentCommunityEvent = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    return (
        <>
            <RenderMeta title={t("meta.historyredeem_page")} />
            <StyledCommunityEvent themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor
                        color={themes?.themeColor}
                        onClick={() => history.push(PATH_HOME)}
                    />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="titlepage">
                    <h2>Community Events</h2>
                </div>
                <div className="wrapper-community-event">
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">02/17</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-01.png" alt="" />
                            </div>
                            <h2>
                                ONCEs Camp<span>ตอน MAKEUP ARTIST</span>
                            </h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">03/15</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-02.png" alt="" />
                            </div>
                            <h2>Make up class Event</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">04/12</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-03.png" alt="" />
                            </div>
                            <h2>Beauty Class Event</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">04/21</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-04.png" alt="" />
                            </div>
                            <h2>Make Up Tutorial Event</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">05/09</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-05.png" alt="" />
                            </div>
                            <h2>Personal Color Event</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">05/13</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-06.png" alt="" />
                            </div>
                            <h2>Make Up look Event</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">07/18</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-07.png" alt="" />
                            </div>
                            <h2>MEGA SPACE MOLLY</h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>

                    <div className="layout-community-event">
                        <div className="datetime-community-event">
                            <div className="date">08/19</div>
                            <div className="time">07:45-10:00</div>
                        </div>
                        <div className="content-community-event">
                            <div className="img-community-event">
                                <img src="../images/img-communityevent-new-08.png" alt="" />
                            </div>
                            <h2>
                                Workshop<span>by Professional Event</span>
                            </h2>
                            <div className="location">Phrom Phong,Sukhumvit 24</div>
                            <div className="person">
                                <span className="now">18</span>/<span className="max">50</span>
                            </div>
                            <div className="btn-join">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_COMMUNITY_EVENT_DETAIL)}
                                >
                                    Join
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </div>
                </div>
            </StyledCommunityEvent>
        </>
    );
};

const StyledCommunityEvent = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    // background-color: #FFFFFF;
    background: linear-gradient(180deg, rgba(225, 231, 237, 1) 0%, rgba(255, 255, 255, 1) 50%);
    position: relative;
    background-size: cover;
    .wrapper-community-event {
        padding: 0 16px;
        .layout-community-event {
            position: relative;
            padding: 16px 0;
            padding-left: 70px;
            border-bottom: 1px solid #f0f0f0;
            &:last-child {
                border: none;
            }
            .datetime-community-event {
                position: absolute;
                width: 60px;
                left: 0;
                text-align: center;
                .date {
                    font-size: 16px;
                    color: #d2001f;
                    margin-bottom: 8px;
                    font-weight: 600;
                }
                .time {
                    font-size: 10px;
                    color: #9b9b9b;
                }
            }
            .content-community-event {
                position: relative;
                padding-left: 75px;
                padding-right: 65px;
                .img-community-event {
                    position: absolute;
                    width: 64px;
                    height: 64px;
                    border-radius: 8px;
                    left: 0;
                    top: 0;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                h2 {
                    font-size: 14px;
                    font-weight: 600;
                    color: #000;
                    span {
                        display: block;
                        font-weight: 600;
                    }
                }
                .location {
                    color: #9b9b9b;
                    font-size: 10px;
                    background-image: url(../images/location-event.svg);
                    background-position: left center;
                    background-repeat: no-repeat;
                    background-size: 10px;
                    font-size: 10px;
                    color: #9b9b9b;
                    padding-left: 16px;
                    margin-bottom: 6px;
                }
                .person {
                    color: #9b9b9b;
                    font-size: 10px;
                    background-image: url(../images/person-event.svg);
                    background-position: left center;
                    background-repeat: no-repeat;
                    background-size: 10px;
                    font-size: 10px;
                    color: #9b9b9b;
                    padding-left: 16px;
                }
                .btn-join {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
    .titlepage {
        text-align: center;
        margin-bottom: 16px;
        padding: 30px 16px 0;
        h2 {
            font-size: 16px;
            font-weight: 600;
            color: #000;
            margin-bottom: 5px;
        }
        p {
            font-size: 14px;
            color: #525257;
            line-hegiht: 20px;
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 10px 12px;
    color: #000;
    background: #fff;
    border: 0.5px solid #e1e1e1;
    border-radius: 12px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
